import { render, staticRenderFns } from "./RidersModal.vue?vue&type=template&id=17a4eff9&lang=pug&"
import script from "./RidersModal.vue?vue&type=script&lang=js&"
export * from "./RidersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports